import { PathCategory, imagePath } from '@shared/config/imgPath';
import { A1_STATIC_URL } from '@shared/env';

/**
 *
 */
export const getCNetVideo = (mediaUrl: string, mediaPath: string = 'assets/application/form/') => {
	if (!mediaUrl) return undefined;

	return `${A1_STATIC_URL}/${mediaPath}${mediaUrl}`;
};
/**
 * @description 通过分类获取图片路径
 * @param classify 分类名称
 * @param imgName 图片名
 * @returns
 */
export const getImagePath = (classify: PathCategory, imgName: string) => {
	if (!imgName) {
		return '';
	} else {
		return A1_STATIC_URL + '/assets' + imagePath[classify].replace('${content}', imgName);
	}
};

/**
 * 获取风格图片
 */
export const getStyleImage = (imageName: string) => {
	if (!imageName) {
		return '';
	} else {
		return (JSON.parse(imageName) as string[]).map(
			(v) => `${A1_STATIC_URL}/assets/style/cover_image/${v}`,
		);
	}
};

/**
 * [获取应用的相关图片]
 */
export const getAppImg = (appId?: string, versionId?: string, imgName?: string) => {
	if (!appId || !versionId || !imgName) return '';
	return A1_STATIC_URL + `/assets/images/app_${appId}/${versionId}/` + imgName;
};

/**
 * [获取cnet的相关图片]
 */
export const getCNetImg = (appId: string, imgName: string) => {
	return A1_STATIC_URL + `/assets/application/app_${appId}/form/` + imgName;
};

/**
 * 获取 cnet 图片，有前缀的情况下拼接前缀
 * @param appId
 * @param imageName
 * @param path
 */
export const getCNetImgWithPath = (appId: string, imageName: string, path?: string) => {
	if (!imageName) return undefined;

	// 通过历史记录等方式获取的完整 url
	if (path?.length) {
		return `${A1_STATIC_URL}/${path}${imageName}`;
	}

	return getCNetImg(appId, imageName);
};

export const getMaskImg = (imageName: string, path: string = '') => {
	if (!imageName) return undefined;
	return `${A1_STATIC_URL}/${path}${imageName}`;
};

export const DEFAULT_DIGITAL_PATH = 'assets/digital_avatar/origin/cover_image/';
/**
 * [获取数字分身图片]
 */
export const getDigitalAvatarImg = (imgName: string) => {
	return A1_STATIC_URL + `/${DEFAULT_DIGITAL_PATH}${imgName}`;
};

/**
 * @description 通过链接方式获取文件名
 * @param href 链接
 * @returns 文件名
 */
export const getFileNameByUrl = (href: string) => {
	if (href) {
		const url = new URL(href);
		return url.pathname.split('/').pop();
	} else {
		return '';
	}
};

// 获取视频模版图片链接
export const getActionImagePath = (imgName: string) => {
	return A1_STATIC_URL + '/assets/action-template/cover/' + imgName;
};

// 后端给我们拼好了图片路径的情况
export const getImgUrl = (path?: string) => {
	return A1_STATIC_URL + path;
};

//视频换脸路径
export const getFaceSwapImg = (name?: string) => {
	return A1_STATIC_URL + '/assets/template/video/rs/' + name;
};

export const getImgUrlV2 = (path?: string) => {
	if (!path) return '';
	return `${A1_STATIC_URL}/${path.replace(/^\/+/, '')}`;
};

//banner图片
export const isCompleteImagePath = (path?: string): boolean => {
	if (!path) {
		return false;
	}
	const regex = /^https:\/\/.*\.(jpg|jpeg|png|gif|bmp|webp)$/i;
	return regex.test(path);
};

export const getBannerImageSrc = (image?: string) => {
	if (!image) return '';
	return isCompleteImagePath(image) ? image : `${A1_STATIC_URL}/${image}`;
};

export const extractAssetPath = (url?: string): string => {
	if (!url) return '';
	const [path] = url.split('?');
	const match = path.match(/\/(assets\/.+)/);
	return match ? match[1] : '';
};

export const getStaticAssetUrl = (url?: string) => {
	if (!url) return '';
	if (/^(blob:|data:)/.test(url)) return url;
	if (/^https?:\/\//.test(url)) {
		const assetPath = extractAssetPath(url);
		return assetPath ? getImgUrlV2(assetPath) : url;
	}
	return getImgUrlV2(url);
};
